<div class="topTileview" *ngIf="RoomTopicList !=''">
  <div class="tile is-ancestor is-4">
    <div class="tile">
      <div class="tile is-parent is-vertical">
        <article class="tile is-child box" *ngFor="let item of RoomTopicList; let i=index">
          <p class="title">{{item.topic}}</p>
          <p class="subtitle">{{item.created_at | date: 'dd MMM yyyy'}}</p>
          <div class="content">
            <p>{{item.notes}}</p>
          </div>
          <footer class="tileViewFooter">
            <div *ngIf="item.file_ext=='mp3' || item.file_ext=='mp4' || item.file_ext=='wav' || item.file_ext=='avi' || item.file_ext=='flv'; else tileViewTemplate">
              <a class="button is-small">
                <i class="fa fa-eye is-small" aria-hidden="true"></i>
              </a>
            </div>
            <ng-template #tileViewTemplate>
              <a class="button is-small">
                <i class="fa fa-download is-small" aria-hidden="true"></i>
              </a>
            </ng-template>
            <a class="button is-small">
              <i class="fa fa-share-alt-square" aria-hidden="true"></i>
            </a>
            <a class="button is-small" (click)="deletedTopic(item.topic_id)">
              <i class="fa fa-trash" aria-hidden="true"></i>
            </a>
            <a class="button is-small">Publish</a>
          </footer>
        </article>
      </div>
    </div>
</div>
